import type { BarCategory, BarSeries } from '@/components/charts/BarChart';
import { formatMoney } from '@/lib/dataFormat';
export const CHART_HOME = '/design/charts';
import { CHART_MONTHS_RU } from '@/components/charts/chartData';
const monthNames = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];
export function monthlySample(year: string, net = false): { categories: BarCategory[]; series: BarSeries[] } {
  const factor = year === '2024' ? 0.88 : 1;
  const income = [
    248000,
    282000,
    0,
    338000,
    324000,
    null,
    378000,
    351000,
    412000,
    386000,
    432000,
    468000,
  ].map((v) => (v === null ? null : Math.round(v * 100 * factor)));
  const expense = [
    186000,
    221000,
    92000,
    247000,
    256000,
    263000,
    294000,
    null,
    326000,
    338000,
    372000,
    391000,
  ].map((v) => (v === null ? null : Math.round(v * 100 * factor)));
  return {
    categories: CHART_MONTHS_RU.map((label, i) => ({
      key: year + '-' + String(i + 1).padStart(2, '0'),
      label,
      longLabel: monthNames[i] + ' ' + year,
    })),
    series: net
      ? [
          {
            id: 'net',
            label: 'Сальдо',
            values: income.map((v, i) => (v === null || expense[i] === null ? null : v - expense[i])),
            color: 3,
          },
        ]
      : [
          { id: 'in', label: 'Поступления', values: income, color: 2 },
          { id: 'out', label: 'Расходы', values: expense, color: 4 },
        ],
  };
}
export const moneyValue = (v: number) => formatMoney(v, 'RUB');
export const moneyTick = (v: number) =>
  new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(v / 100000);
export function dailySample(year: string, metric: string) {
  const values: Record<string, number | null> = {};
  const from = year + '-01-01',
    to = year + '-04-30';
  const start = new Date(from + 'T12:00:00Z'),
    end = new Date(to + 'T12:00:00Z');
  for (let date = start, i = 0; date <= end; date = new Date(date.getTime() + 86400000), i++) {
    const key = date.toISOString().slice(0, 10);
    values[key] =
      i % 19 === 8 ? null : i % 13 === 0 ? 0 : metric === 'hours' ? 4 + ((i * 7) % 21) : 2 + ((i * 11) % 31);
  }
  return { from, to, values, domainMax: metric === 'hours' ? 24 : 32 };
}
